import React from 'react';
import { ActivityIndicator, View } from 'react-native';
import { createStyleSheet } from '../../utils';
import { useStyleSheet, useThemeContext } from '../../hooks';
export const Loader = ({ full, style, loaderStyle, size, color }) => {
    const styles = useStyleSheet(getStyles);
    const theme = useThemeContext();
    return (React.createElement(View, { style: [styles.container, full ? styles.full : {}, style] },
        React.createElement(ActivityIndicator, { size: size, style: loaderStyle, color: color !== null && color !== void 0 ? color : theme.color.primary.solid })));
};
const getStyles = createStyleSheet(() => ({
    container: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    full: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    }
}));
//# sourceMappingURL=index.js.map